var ResponseUtil = /** @class */ (function () {
    function ResponseUtil() {
    }
    ResponseUtil.success = function (data) { return ({
        resultCode: "SUCCESS",
        data: data
    }); };
    // This is used instead of a constant so that it has the correct generic type to match its usage.
    ResponseUtil.error = function () { return ({ resultCode: "UNEXPECTED_ERROR" }); };
    return ResponseUtil;
}());
export { ResponseUtil };
//# sourceMappingURL=ResponseUtil.js.map